import React, { useState } from 'react';
import { Record, RecordCircle } from 'iconsax-react'
import '../styles.css';

export const displayMethod = {
  block: {name: 'block', class: 'displaycolumn' },
  flex:  {name: 'flex',  class: 'displayRow' },
  wrap:  {name: 'wrap',  class: 'displayWrap' },
}

function InputCheck({ methodDisplay, list }) {
  return (
    <div className={methodDisplay?.class}>
      {
        list.map((index, key) => {
          return (
            <div key={key} className='optionCheck' onClick={()=>index.change()}>
              {index.isActive
                ? <RecordCircle size="20" color="#104172" variant="Bold" />
                : <Record size="20" color="#104172" />
              }
              <p className='textSimpleBlue' style={{marginLeft:3}}>{index.label}</p>
            </div>
          )
        })
      }
    </div>
  )
}


export default InputCheck;